/**
 * 所属行业
 */

import {
  get,
  post,
  put,
  del
} from '@/util/request'
import download from "@/util/download";

/**
 * 根据Id查询
 * @param {*} data
 * @returns
 */
export const SelectInjuryTypeById = (Id) => {
  return get('/api/app/injuryType?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddInjuryType = (data) => {
  return post('/api/app/injuryType', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyInjuryType = (data) => {
  return put('/api/app/injuryType', data, {});
}

/**
 * 分页获取所属行业
 * @param {*} data
 * @returns
 */
export const GetDataInjuryTypeList = (data) => {
  return post('/api/app/injuryType/list', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteInjuryType = (id) => {
  return del('/api/app/injuryType/' + id, {}, {});
}

/**
 * 导出Excel
 * @param {*} id
 * @returns
 */
 export const ExportInjuryType = (data) => {
  let defaluturl = `/api/app/InjuryType/exportExcelFile`;
  let fileName = "所属行业"
  return download(fileName, defaluturl, data);
}